import { executeRequest } from "@/common/utils/http/httpClient";
import { getCurrentEnvironmentVariables } from "@/lib/CONSTANTS";
import { endpointMapper } from "@/common/service/endpoint.map.js";
import { replaceAllMatchPattern, queryParamGenerator } from "@/common/utils/generic/commonHelper.js";

const envSpecificApiDomain = getCurrentEnvironmentVariables().apiDomain;

const subPath = "v1";

const workflowApiPath = `${replaceAllMatchPattern(envSpecificApiDomain[subPath], endpointMapper[subPath].workflow)}`;

/**
 * totalSearchRecordService
 * @description: Function which will trigger async call to get total count of group search selection
 * @returns: Total count number
 * @param: Query object with groupId, startDate, endDate
 */
const totalSearchRecordService = async params => {
  const url = `${workflowApiPath}/workflowtask/search/count${queryParamGenerator(params)}`;

  return executeRequest({
    url,
    method: "GET"
  });
};

const groupSearchResultService = async (params, rawResponse = false) => {
  const url = `${workflowApiPath}/workflowtask/search${queryParamGenerator(params)}`;

  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

/**
 * complainceService
 * @description: Function which will trigger async call to get respective complaince data
 *              based on the group result selection which has complainceID to trigger this API
 * @returns Array of complaince data object
 * @param: Query object with groupId, fromDate, toDate, it also has page and size which isn't required as per VD
 */
const complainceService = async (params, rawResponse = false) => {
  const url = `${workflowApiPath}/workflowtask/compliance${queryParamGenerator(params)}`;
  return executeRequest({
    url,
    method: "GET",
    rawResponse
  });
};

/**
 * returnCargo
 * @description: Function which will trigger async call to update on the data
 *              based on the business key attribute Params to trigger this API
 * @returns Updated object
 */
const returnCargo = async (businessKey, rawResponse = false) => {
  const url = `${workflowApiPath}/workflowtask/close?businessKey=${businessKey}`;
  return executeRequest({
    url,
    method: "PUT",
    rawResponse
  });
};

export { returnCargo, complainceService, groupSearchResultService, totalSearchRecordService };
